import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import LoaderScreen from "../components/LoaderScreen";

export default function IndexPage() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/todo");
  });
  return <LoaderScreen />;
}
